import { Flex, Tag } from "antd";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { CardItem } from "../../../CommonElements/Card";
import { HugeiconsIcon } from "@hugeicons/react";
import ArrivalCardSkeleton, { ArrivalCardSkeletonNoCol } from "./ArrivalCardSkeleton";
import { cn } from "../../../utils/helpers";

export const ArrivalCard = ({ arrival, loading = false, renderActions, departureCard, ...rest }) => {
  if (loading) {
    return <ArrivalCardSkeleton />;
  }
  if (!arrival) {
    return null;
  }
  return (
    <Col xs={12} md={6} lg={6} xl={4}>
      <ArrivalCardNoCol
        {...rest}
        arrival={arrival}
        loading={loading}
        renderActions={renderActions}
        departureCard={departureCard}
      />
    </Col>
  );
};

export const ArrivalCardNoCol = ({ arrival, loading = false, renderActions, departureCard, ...rest }) => {
  if (loading) {
    return <ArrivalCardSkeletonNoCol />;
  }
  if (!arrival) {
    return null;
  }

  const { statusConfig, actions, extra, labelValues, title, titleValue, bottomOffset ,groupName} = rest ?? {};
  return (
    <CardItem>
      <div style={{ position: "relative", zIndex: 1, backgroundColor: "white" }} className="pt-3">
        <CardItem.Header>
          <div style={{ marginBottom: "16px" }}>
            <Flex justify="space-between" align="center" gap={2}>
              <div>
                <h3 className="H5 m-0 d-flex align-items-center gap-2 flex-wrap">
                  <span>{title} {titleValue || "-"}</span> {groupName && <span className="  fw-bold" style={{fontSize:"9px"}}>({groupName})</span>}
                </h3>
              </div>

              <Flex align="center" gap={4}>
                {statusConfig && !departureCard && (
                  <Tag className={cn("d-flex align-items-center gap-2 m-0", statusConfig?.color ?? "red")}>
                    {statusConfig?.text && <span>{statusConfig?.text}</span>}
                    {statusConfig?.icon && <HugeiconsIcon icon={statusConfig?.icon} />}
                  </Tag>
                )}
                {renderActions && renderActions()}
              </Flex>
            </Flex>
          </div>
        </CardItem.Header>
      </div>
      {/* -------- */}
      <Row>
        {labelValues?.map?.(({ hide = () => false, ...labelValue }) =>
          hide(arrival) === true ? (
            <></>
          ) : (
            <LabelValue
              key={labelValue.key}
              label={labelValue.label}
              value={labelValue?.render?.(arrival[labelValue.key], arrival) || arrival[labelValue.key] || "-"}
              colSize={labelValue?.fullWidth ? { xs: 12, md: 12, lg: 12 } : labelValue?.colSize}
            />
          ),
        )}
      </Row>

      {extra}

      {/* -------- */}
      {actions && (
        <div style={{ position: "sticky", bottom: 0, backgroundColor: "white" }} className="pb-3">
          <CardItem.Footer
            style={{
              position: "sticky",
              bottom: `${bottomOffset}px`,
              backgroundColor: "white",
            }}
          >
            <Flex justify="space-between" align="center" className="pt-3" wrap gap={4}>
              {actions}
            </Flex>
          </CardItem.Footer>
        </div>
      )}
    </CardItem>
  );
};
const LabelValue = ({ label, value, colSize }) => {
  const defaultColSize = { xs: 6, md: 6 };
  return (
    <Col {...{ ...defaultColSize, ...(colSize ?? {}) }} className="p-2">
      <div className="H7 text-secondary mb-1">{label}</div>
      <div className="H6 text-primary">{value}</div>
    </Col>
  );
};

// -------
